import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Scroller from "../components/scroller"

import Inicio from '../components/sections/Inicio';
import Sobre from '../components/sections/Sobre';
import Contacto from '../components/sections/Contacto';
import LlamadoAccion from '../components/sections/LlamadoAccion';
import LlamadoCesione from '../components/sections/LLamadoCesione';
import Clientes from '../components/sections/Clientes';

export default class IndexPage extends React.Component {
  constructor(props) {
    super(props)
    Scroller.handleAnchorScroll = Scroller.handleAnchorScroll.bind(this)
    this.state = {
      modalShow: false,
      modalCurrent: 0
    }
    this.handlePortfolioClick = this.handlePortfolioClick.bind(this);
    this.setModal = this.setModal.bind(this);
  }

  handlePortfolioClick(index, e) {
    e.preventDefault();
    this.setModal(true, index);
  }

  setModal(isShown, current) {
    this.setState({
      modalShow: isShown,
      modalCurrent: current
    });
  }

  render() {
    return (
      <Layout>
        <SEO title="Monitor de cesiones" />
        <Inicio id="inicio" />
        <Sobre id="sobre" scroll={Scroller.handleAnchorScroll} />
        <LlamadoAccion id="llamado" />
        <Clientes id="clientes" />
        <LlamadoCesione id="cesione" />
        <Contacto id="contacto" />
      </Layout>
    )
  }
}


export const imageData = graphql`
  query {
    images: allFile(filter: {relativePath: {glob: "portfolio/fullsize/*.jpg"}}, sort: {fields: name}) {
      edges {
        node {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`
